<template>
  <div class="contact">
    <div class="MainOne">
      <img src="../assets/image/增值服务.jpg" alt="" style="height: 490px" />
    </div>
    <div class="MainTwo">
      <div style="width: 100%; margin: 0 auto">
        <div class="right_letter">做有意义的事，成就有意义的人生!</div>
      </div>
      <h2>增值服务</h2>
      <h3>value-added services</h3>

      <div class="total">
        <div class="total_top">
          <div class="corporate_mission">
            <div class="mission-text" id="sectionA">信息运维</div>
            <div class="en_letter">INFORMATION OPERATION AND MAINTENANCE</div>
          </div>

          <div class="corporate_mission_1">
            <div class="mission-text">智能产线</div>
            <div class="en_letter" style="color: #fff">
              INTELLIGENT PRODUCTION LINE
            </div>
          </div>
        </div>
        <div class="total_top_1">
          <div class="corporate_mission_2">
            <div class="mission-text">智能工厂</div>
            <div class="en_letter" style="color: #fff">SMART FACTORY</div>
          </div>
          <div class="corporate_vision_3">
            <div class="mission-text">洁净室验证</div>
            <div class="en_letter" style="color: #fff">
              CLEANROOM VALIDATION
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerCase",
  mounted() {
    this.scrollToPosition();
  },
  watch: {
    "$route.query.scrollTo"(newVal) {
      this.scrollToPosition(newVal);
    },
  },
  data() {
    return {};
  },
  methods: {
    scrollToPosition(section = null) {
      let element = null;
      if (section) {
        element = document.querySelector(`#${section}`);
      } else {
        // 默认滚动到页面顶部
        element = document.body;
      }
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>
<style>
@media (max-width: 966px) {
  .MainOne {
    display: none;
  }
}
.en_letter {
  font-size: 16px;
}

.corporate_mission {
  background-image: url(../assets/image/信息运维.png);
  background-size: cover; /* 让背景图覆盖整个div */
  background-position: center; /* 图像居中显示 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #333; /* 假设文字颜色是白色，以便在背景图上清晰可见 */
  transition: background-color 0.5s ease; /* 添加背景色过渡效果 */
  /* 添加一个半透明的黑色背景，以便在鼠标悬停时使背景图变暗 */
  background-color: rgba(0, 0, 0, 0.3); /* 初始时就有一定的暗度 */
  position: relative;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2), 0 5px 10px rgba(0, 0, 0, 0.1); /* 更强的阴影效果 */
  opacity: 0.5s;
}

.corporate_mission .mission-text {
  font-size: 24px;
  color: #333; /* 文本颜色 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

.corporate_mission:hover .mission-text {
  opacity: 0;
}

.corporate_mission:hover {
  background-color: rgba(0, 0, 0, 1); /* 鼠标悬停时增加暗度 */
}

/* 初始状态下显示企业使命和英文字母 */
.corporate_mission .mission-text,
.corporate_mission .en_letter {
  opacity: 1;
  transition: opacity 0.5s ease; /* 添加透明度过渡效果 */
}

.corporate_mission:hover .mission-text,
.corporate_mission:hover .en_letter {
  opacity: 0; /* 鼠标悬停时隐藏 */
}

.corporate_mission::before {
  content: "为客户提供驻点软件、硬件、数据运维";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* 居中显示 */
  font-size: 25px; /* 字体大小 */
  color: #333; /* 文本颜色 */
  white-space: nowrap; /* 防止文本换行 */
  border-bottom: 1px solid #333; /* 底部白线 */
  padding-bottom: 5px; /* 白线与文本之间的间距 */
  opacity: 0; /* 初始状态隐藏 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

.corporate_mission::after {
  content: "";
  position: absolute;
  top: calc(40% + 40px);
  left: 50%;
  transform: translateX(-50%); /* 水平居中 */
  font-size: 20px; /* 字体大小 */
  color: #333; /* 文本颜色 */
  white-space: nowrap; /* 防止文本换行 */
  opacity: 0; /* 初始状态隐藏 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

/* 鼠标悬停时显示两个伪元素 */
.corporate_mission:hover::before,
.corporate_mission:hover::after {
  opacity: 1; /* 鼠标悬停时显示 */
}
.corporate_vision_3 {
  background-image: url(../assets/image/洁净室验证.png);
  background-size: cover; /* 让背景图覆盖整个div */
  background-position: center; /* 图像居中显示 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff; /* 假设文字颜色是白色，以便在背景图上清晰可见 */
  transition: background-color 0.5s ease; /* 添加背景色过渡效果 */
  /* 添加一个半透明的黑色背景，以便在鼠标悬停时使背景图变暗 */
  background-color: rgba(0, 0, 0, 0.3); /* 初始时就有一定的暗度 */
  position: relative;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2), 0 5px 10px rgba(0, 0, 0, 0.1); /* 更强的阴影效果 */
}

.corporate_vision_3 .mission-text {
  font-size: 24px;
  color: #fff; /* 文本颜色 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

.corporate_vision_3:hover .mission-text {
  opacity: 0;
}

.corporate_vision_3:hover {
  background-color: rgba(0, 0, 0, 1); /* 鼠标悬停时增加暗度 */
}

/* 初始状态下显示企业使命和英文字母 */
.corporate_vision_3 .mission-text,
.corporate_vision_3 .en_letter {
  opacity: 1;
  transition: opacity 0.5s ease; /* 添加透明度过渡效果 */
}

.corporate_vision_3:hover .mission-text,
.corporate_vision_3:hover .en_letter {
  opacity: 0; /* 鼠标悬停时隐藏 */
}

.corporate_vision_3::before {
  content: "洁净室的三种验收状态及结果认证、";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* 居中显示 */
  font-size: 25px; /* 字体大小 */
  color: #fff; /* 文本颜色 */
  white-space: nowrap; /* 防止文本换行 */
  border-bottom: 1px solid #333; /* 底部白线 */
  padding-bottom: 5px; /* 白线与文本之间的间距 */
  opacity: 0; /* 初始状态隐藏 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

.corporate_vision_3::after {
  content: "第三方认证、远程达标认证等";
  position: absolute;
  top: calc(40% + 40px);
  left: 50%;
  transform: translateX(-50%); /* 水平居中 */
  font-size: 25px; /* 字体大小 */
  color: #fff; /* 文本颜色 */
  white-space: nowrap; /* 防止文本换行 */
  opacity: 0; /* 初始状态隐藏 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

/* 鼠标悬停时显示两个伪元素 */
.corporate_vision_3:hover::before,
.corporate_vision_3:hover::after {
  opacity: 1; /* 鼠标悬停时显示 */
}
.total_top div {
  width: 43%;
  background-repeat: no-repeat;
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1); /* 添加阴影，创建立体感 */
  border-radius: 10px; /* 圆角 */
}
.total_top {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 300px;
  margin-bottom: 40px;
  margin-top: 41px;
}
.total {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
  color: #333;
  font-size: 24px;
}
.corporate_mission_2 {
  background-image: url(../assets/image/智能工厂.png);
  background-size: cover; /* 让背景图覆盖整个div */
  background-position: center; /* 图像居中显示 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #333; /* 假设文字颜色是白色，以便在背景图上清晰可见 */
  transition: background-color 0.5s ease; /* 添加背景色过渡效果 */
  /* 添加一个半透明的黑色背景，以便在鼠标悬停时使背景图变暗 */
  background-color: rgba(0, 0, 0, 0.3); /* 初始时就有一定的暗度 */
  position: relative;
}

.corporate_mission_2 .mission-text {
  font-size: 24px;
  color: #fff; /* 文本颜色 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

.corporate_mission_2:hover .mission-text {
  opacity: 0;
}

.corporate_mission_2:hover {
  background-color: rgba(0, 0, 0, 1); /* 鼠标悬停时增加暗度 */
}

/* 初始状态下显示企业使命和英文字母 */
.corporate_mission_2 .mission-text,
.corporate_mission_2 .en_letter {
  opacity: 1;
  transition: opacity 0.5s ease; /* 添加透明度过渡效果 */
}

.corporate_mission_2:hover .mission-text,
.corporate_mission_2:hover .en_letter {
  opacity: 0; /* 鼠标悬停时隐藏 */
}

.corporate_mission_2::before {
  content: "统筹规划、分布实施的工厂";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* 居中显示 */
  font-size: 25px; /* 字体大小 */
  color: #fff; /* 文本颜色 */
  white-space: nowrap; /* 防止文本换行 */
  border-bottom: 1px solid #333; /* 底部白线 */
  padding-bottom: 5px; /* 白线与文本之间的间距 */
  opacity: 0; /* 初始状态隐藏 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

.corporate_mission_2::after {
  content: "智能智造设计、建造、改造等服务";
  position: absolute;
  top: calc(40% + 40px);
  left: 50%;
  transform: translateX(-50%); /* 水平居中 */
  font-size: 25px; /* 字体大小 */
  color: #fff; /* 文本颜色 */
  white-space: nowrap; /* 防止文本换行 */
  opacity: 0; /* 初始状态隐藏 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

/* 鼠标悬停时显示两个伪元素 */
.corporate_mission_2:hover::before,
.corporate_mission_2:hover::after {
  opacity: 1; /* 鼠标悬停时显示 */
}

.corporate_mission_1 {
  background-image: url(../assets/image/智能产线.png);
  background-size: 100% 100%; /* 让背景图覆盖整个div */
  background-position: center; /* 图像居中显示 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff; /* 假设文字颜色是白色，以便在背景图上清晰可见 */
  transition: background-color 0.5s ease; /* 添加背景色过渡效果 */
  /* 添加一个半透明的黑色背景，以便在鼠标悬停时使背景图变暗 */
  background-color: rgba(0, 0, 0, 0.3); /* 初始时就有一定的暗度 */
  position: relative;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2), 0 5px 10px rgba(0, 0, 0, 0.1); /* 更强的阴影效果 */
}

.corporate_mission_1 .mission-text {
  font-size: 24px;
  color: #fff; /* 文本颜色 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

.corporate_mission_1:hover .mission-text {
  opacity: 0;
}

.corporate_mission_1:hover {
  background-color: rgba(0, 0, 0, 1); /* 鼠标悬停时增加暗度 */
}

/* 初始状态下显示企业使命和英文字母 */
.corporate_mission_1 .mission-text,
.corporate_mission_1 .en_letter {
  opacity: 1;
  transition: opacity 0.5s ease; /* 添加透明度过渡效果 */
}

.corporate_mission_1:hover .mission-text,
.corporate_mission_1:hover .en_letter {
  opacity: 0; /* 鼠标悬停时隐藏 */
}

.corporate_mission_1::before {
  content: "产线的设计、建造、改造等智能化服务";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* 居中显示 */
  font-size: 25px; /* 字体大小 */
  color: #fff; /* 文本颜色 */
  white-space: nowrap; /* 防止文本换行 */
  border-bottom: 1px solid #333; /* 底部白线 */
  padding-bottom: 5px; /* 白线与文本之间的间距 */
  opacity: 0; /* 初始状态隐藏 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

.corporate_mission_1::after {
  content: "";
  position: absolute;
  top: calc(40% + 40px);
  left: 50%;
  transform: translateX(-50%); /* 水平居中 */
  font-size: 20px; /* 字体大小 */
  color: #fff; /* 文本颜色 */
  white-space: nowrap; /* 防止文本换行 */
  opacity: 0; /* 初始状态隐藏 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

/* 鼠标悬停时显示两个伪元素 */
.corporate_mission_1:hover::before,
.corporate_mission_1:hover::after {
  opacity: 1; /* 鼠标悬停时显示 */
}
.total_top_1 div {
  width: 43%;
  background-repeat: no-repeat;
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1); /* 添加阴影，创建立体感 */
  border-radius: 10px; /* 圆角 */
}
.total_top_1 {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 300px;
  margin-bottom: 40px;
}
.total {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
  color: #333;
  font-size: 24px;
}
.MainOne {
  height: 490px;
}
el-form-item {
  list-style: 56px;
}

.right_letter {
  border-bottom: 2px solid #333;
  text-align: right;
  margin-top: 52px;
}
.contact {
  width: 100%;
  height: auto;
  margin: 0 auto;
  background-color: rgb(243, 245, 245);
}
.MainTwo {
  width: 88%;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 60px;
}
.contact hr {
  color: rgb(136, 126, 126);
}
h2 {
  text-align: right;
  text-align: left;
  color: blue;
  margin-top: 10px;
}
.contact h3 {
  text-align: left;
  color: grey;
  margin-bottom: 30px;
}
</style>
